type MemberModalProps = {
  show: boolean
  onClose: () => void
  members: {name: string}[]
}

const MemberModal: React.FC<MemberModalProps> = ({show, onClose, members}) => {
  if (!show) return null

  return (
    <div className='modal fade show d-block' style={{backgroundColor: 'rgba(0,0,0,0.3)'}}>
      <div className='modal-dialog modal-sm modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header py-2'>
            <h6 className='modal-title'>Point Of Contact</h6>
            <button
              type='button'
              className='btn-close'
              style={{
                outline: 'none',
                boxShadow: 'none',
              }}
              onClick={onClose}
            />
          </div>

          <div className='modal-body py-2'>
            {members.length ? (
              <ul className='mb-0 ps-3'>
                {members.map((m, i) => (
                  <li key={i} className='mb-1'>
                    {m.name}
                  </li>
                ))}
              </ul>
            ) : (
              <span className='text-muted'>No members</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default MemberModal
